import BaseClient from '@/app/model/api/response/baseApiClient'

class ExternalLinkContentDeleteApi extends BaseClient {
  public doExternalLinkContentDelete (id: string) {
    const path: string = '/v1/external-link-contents/' + id

    /* 共通処理 */
    return super.doFetch(process.env.VUE_APP_API_URL + path, 'DELETE')
  }
}

export default new ExternalLinkContentDeleteApi()
